import { EmptyStateBase } from "@skailer-com/uikit";
import analyticsService, { analyticEvents } from "@/services/analytics-service.ts";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useEffectOnce } from "react-use";

export default function EmptyStateServerError() {
  const { t } = useTranslation();
  const timerRef = useRef<number | null>(null);

  useEffectOnce(() => {
    analyticsService.trackEvent(analyticEvents.serverErrorViewed);
  });

  useEffect(() => {
    const startReloadTimer = (): void => {
      if (timerRef.current !== null) {
        window.clearTimeout(timerRef.current);
      }

      if (document.visibilityState === "visible") {
        timerRef.current = window.setTimeout(() => {
          window.location.reload();
        }, 10000);
      }
    };

    startReloadTimer();

    const handleVisibilityChange = (): void => {
      if (document.visibilityState === "visible") {
        startReloadTimer();
      } else if (timerRef.current !== null) {
        window.clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      if (timerRef.current !== null) {
        window.clearTimeout(timerRef.current);
      }
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  return <EmptyStateBase emoji={":shrug:"} title={t("errors:server_error")} />;
}
